module.exports = "/static/assets/4f54696394286eb7a94c5dbc36930a89.png";